module.exports = __webpack_public_path__ + "static/media/plus.23861d43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plus.svg
// module id = 423
// module chunks = 3